import './App.css';

import Card from '@mui/material/Card';
import CardContent from '@mui/material/CardContent';

import image02 from './images/HP01.jpg';

function MapPageSummary() {

    return (
        <div>
            <Card>
                <CardContent >
                    <p className="Tab-Section-body" >
                        GDS Google Maps is a .Net User Control, which integrates interactive Google Maps into your desktop applications,
                        providing a fast and convenient way for software developers to display customized geographic data on top of Google Maps
                        and perform Google Maps based operations and computations.
                    </p>
                    <br />
                    <p className="Tab-Section-body" >
                        GDS Google Maps combines the power of .Net Desktop Control and Google Maps API to provide an enhanced mapping experience. Currently,
                        there are two editions available:
                    </p>
                    <br />
                    <table>
                        <tr >
                            <td>
                                <p className="Tab-Section-body-purple" >GDS Google Maps WinForms (.Net 9.0 and higher)</p>
                            </td>
                            <td width="5%" />
                            <td>
                                <p className="Tab-Section-body-purple" >GDS Google Maps WPF (.Net 9.0 and higher)</p>
                            </td>
                        </tr>
                    </table>
                    <br />
                    <img src={image02} className="Home-Image" alt="GdsGoogleMap" />
                </CardContent>
            </Card>
            <br />
        </div>
    );
}

export default MapPageSummary;
